import React, { useState } from "react";
import axios from "axios";

import "./WeatherForecast.css";
import ForecastPreview from "./ForecastPreview";

export default function WeatherForecast(props) {
  const [loaded, setLoaded] = useState(false);
  const [forecast, setForecast] = useState(null);

  function handleForecast(response) {
    setForecast(response.data);
    setLoaded(true);
  }
  ////forecast.daily[0].temp.min
  if (loaded && props.city === forecast.city.name) {
    return (
      <div>
        <ForecastPreview data={forecast.list[0]} />
        <ForecastPreview data={forecast.list[1]} />
        <ForecastPreview data={forecast.list[2]} />
        <ForecastPreview data={forecast.list[3]} />
        <ForecastPreview data={forecast.list[4]} />
        <ForecastPreview data={forecast.list[5]} />
      </div>
    );
  } else {
    let apiUrl = `https://api.openweathermap.org/data/2.5/forecast?q=${props.city}&appid=193afd01b965f6a8b5609e9278812cbe&units=metric`;

    axios.get(apiUrl).then(handleForecast);
    return null;
  }
}
//appid=193afd01b965f6a8b5609e9278812cbe&units=metrics
//daily[0].temp
